import React from "react";

import TwoPanelDialog, { JustifyContent } from "components/TwoPanelDialog";

import Actions from "./Actions";
import Content from "./Content";
import Open from "./Open";
import Stepper from "./Stepper";
import Title from "./Title";

import { useAppDispatch, useAppSelector } from "store";
import {
    selectPartnerFiltersVisibility,
    hidePartnerFilters,
    // clearFilters
} from "modules/customer/tools/product/partnerFilters/partnerFiltersSlice";

const Partners: React.FC = () => {
    const dispatch = useAppDispatch();
    const filtersVisibility = useAppSelector(selectPartnerFiltersVisibility);
    const isVisible = filtersVisibility.isVisible;

    const handleClose = () => {
        dispatch(hidePartnerFilters());
    };

    return (
        <>
            <Open />
            <TwoPanelDialog
                open={isVisible}
                onClose={handleClose}
                leftPanelTitle={<Title />}
                leftPanelContent={<Stepper />}
                leftPanelActions={<Actions />}
                leftPanelActionsJustifyContent={JustifyContent.SpaceBetween}
                rightPanelContent={<Content />}
            />
        </>
    );
};

export default Partners;
